import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout'
import EditDriver from './EditDriver';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';
import { getReadOnlyUsers } from '../../../helpers/admin/getReadOnlySection';

function action({ store, params, intl }) {
    const title = intl.formatMessage(messages.editDriver);

    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;
    let readOnlyPrivileges = store.getState().account.privileges && store.getState().account.privileges.isReadOnly

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' }
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/drivers/', adminPrivileges, privileges) || getReadOnlyUsers({ privileges, readOnlyUser: readOnlyPrivileges, pageType: '/siteadmin/drivers/' })) {
        return { redirect: '/siteadmin' };
    }

    const id = Number(params.id);
    return {
        title,
        component: (
            <AdminLayout>
                <EditDriver title={title} id={id} isAdmin={isAdminAuthenticated}></EditDriver>
            </AdminLayout>
        )
    }
}

export default action;
